/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:00:41
 * @LastEditors: xgx
 * @LastEditTime: 2022-12-05 16:55:32
 */
import req from "@/utils/request";
export const sendMeSelectList = (params) => req.post("/site-service/m/platformReservation/sendMeSelectList", params);
export const tree = (params) => req.post("/manager-service/m/organization/organTree", params);
export const createDada = (params) => req.post("/site-service/m/submit/create", params);
export const createAndSubmit = (params) => req.post("/site-service/m/submit/createAndSubmit", params);
export const contribute = (params) => req.post("/site-service/m/submit/contribute", params);
export const selectPage = (params) => req.post("/site-service/m/push/selectPage", params);
export const deleteById = (params) => req.post("/site-service/m/push/remove", params);
export const submittedData = (params) => req.post("/site-service/m/push/submitted", params);
export const selectListPage = (params) => req.post("/site-service/m/push/selectListPage", params);
